// A small circular avatar built from the user's initials over a colour derived from their
// name/email, so it stays stable for a given account without needing an uploaded photo.
const COLORS = ['#6f42c1', '#0d6efd', '#198754', '#fd7e14', '#d63384', '#20c997', '#dc3545', '#0dcaf0'];

export function initials(label = '') {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function colorFor(str = '') {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length];
}

export default function Avatar({ name, email, size = 32 }) {
  const label = name || email || '';
  return (
    <span
      className="d-inline-flex align-items-center justify-content-center rounded-circle text-white fw-semibold"
      style={{ width: size, height: size, background: colorFor(label), fontSize: Math.round(size * 0.4), lineHeight: 1 }}
      aria-hidden="true"
    >
      {initials(label)}
    </span>
  );
}
